<template>
    <div class="brand-wrap">
        <div class="brand-wrap_bg">
            <img src="../../assets/img/brand-bg.png" alt="">
        </div>
        <div class="brand-wrap_box1">
            <div class="brand-wrap_title">
                <span>设计理念</span>
                <!-- <img src="../../assets/img/m-title-img.png" alt="" /> -->
            </div>
            <p class="m-brand-font1 u-m-t-40">
                以满足时代特征的审美标准为前提，充分考虑学生群体的生理与心理需求
            </p>
            <p class="m-brand-font2">
                典雅、时尚、简约的外在设计风格以及舒适、实穿、易搭配的内在实用主义
            </p>
            <p class="m-brand-font1">
                在容纳性、耐穿性、合体性、防护性、便利性、功能性、安全性、标识性
            </p>
            <p class="m-brand-font1">
                等方面深入探索，最终实现设计与实用最佳平衡点
            </p>
            <div class="brand-list">
                <div class="brand-item">
                    <div class="brand-img">
                        <img src="../../assets/img/brand-bq1.png" alt="">
                    </div>
                    <div class="brand-title">
                        <div class="brand-text">色彩定制</div>
                        <div class="brand-p">从国际流行色系中获取灵感，根据每所学校的校园文化定制专属配色。</div>
                    </div>
                </div>
                <div class="brand-item">                    
                    <div class="brand-title">
                        <div class="brand-text">款式定制</div>
                        <div class="brand-p">通过精准的版型设计满足学生不同形体和成长的需求</div>
                    </div>
                    <div class="brand-img">
                        <img src="../../assets/img/brand-bq2.png" alt="">
                    </div>
                </div>
            </div>
            <div class="brand-icon-box">
                <div class="brand-icon">
                    <img src="../../assets/img/brand-icon1.png" alt="">
                    <p>安全保证</p>
                </div>
                <div class="brand-icon">
                    <img src="../../assets/img/brand-icon2.png" alt="">
                    <p>专属面料</p>
                </div>
                <div class="brand-icon">
                    <img src="../../assets/img/brand-icon3.png" alt="">
                    <p>严格检测</p>
                </div>
                <div class="brand-icon">
                    <img src="../../assets/img/brand-icon4.png" alt="">
                    <p>反复测试</p>
                </div>
                <div class="brand-icon">
                    <img src="../../assets/img/brand-icon5.png" alt="">
                    <p>舒适版型</p>
                </div>
            </div>

            <div class="brand-list">
                <div class="brand-item">
                    <div class="brand-img">
                        <img src="../../assets/img/brand-bq3.png" alt="">
                    </div>
                    <div class="brand-title">
                        <div class="brand-text">售前</div>
                        <div class="brand-p">从方案设计、款式确认到样衣展示，全程与校方紧密配合，提供全面的数据采集技术支持，做好售前宣导</div>
                    </div>
                </div>
                <div class="brand-item">                    
                    <div class="brand-title">
                        <div class="brand-text">售中</div>
                        <div class="brand-p">根据校服产品货物配发期的特殊性合理安排校服配发系统根据学校需要定期提供调换货服务确保每位学生穿上合体、满意的校服</div>
                    </div>
                    <div class="brand-img">
                        <img src="../../assets/img/brand-bq4.png" alt="">
                    </div>
                </div>
                <div class="brand-item">
                    <div class="brand-img">
                        <img src="../../assets/img/brand-bq5.png" alt="">
                    </div>
                    <div class="brand-title">
                        <div class="brand-text">售后</div>
                        <div class="brand-p">专属400售后电话服务，专属售后人员全程跟进。未经穿着、在不影响二次销售的情况下提供退换货服务，免除校方及家长后顾之忧</div>
                    </div>
                </div>
            </div>
            <!-- <div class="brand-wrap_list">
                <div class="brand-wrap_item">
                    <div class="brand-wrap_item_img">
                        <img src="../../assets/img/brand-img1.png" alt="" />
                    </div>
                    <div class="brand-wrap_item_title">
                        <span>文化提炼</span>
                        <img src="../../assets/img/brand-icon5.png" alt="" />
                    </div>
                    <p>深度挖掘校园文化，表达校园精神内涵，展现学子自信气质</p>
                </div>
                <div class="brand-wrap_item">
                    <div class="brand-wrap_item_img">
                        <img src="../../assets/img/brand-img2.png" alt="" />
                    </div>
                    <div class="brand-wrap_item_title">
                        <span>色彩定制</span>
                        <img src="../../assets/img/brand-icon5.png" alt="" />
                    </div>
                    <p>
                        从国际流行色系中获取灵感，根据每所学校的校园文化定制专属配色。
                    </p>
                </div>
                <div class="brand-wrap_item">
                    <div class="brand-wrap_item_img">
                        <img src="../../assets/img/brand-img3.png" alt="" />
                    </div>
                    <div class="brand-wrap_item_title">
                        <span>版型设计</span>
                        <img src="../../assets/img/brand-icon5.png" alt="" />
                    </div>
                    <p>通过精准的版型设计满足学生不同形体和成长的需求</p>
                </div>
            </div>
            <div class="brand-wrap_bg2"></div>
            <div class="brand-wrap_imgList">
                <div class="brand-wrap_imgItem">
                    <div class="brand-wrap_imgItem_img">
                        <img src="../../assets/img/brand-img4.png" alt="" />
                    </div>
                    <div class="brand-wrap_imgItem_box">
                        <img src="../../assets/img/brand-icon5.png" alt="" />
                        <p class="u-m-t-20">安全保证</p>
                    </div>
                </div>
                <div class="brand-wrap_imgItem">
                    <div class="brand-wrap_imgItem_box">
                        <p class="u-m-b-20">专属面料</p>
                        <img src="../../assets/img/brand-icon5.png" alt="" />
                    </div>
                    <div class="brand-wrap_imgItem_img">
                        <img src="../../assets/img/brand-img5.png" alt="" />
                    </div>
                </div>
                <div class="brand-wrap_imgItem">
                    <div class="brand-wrap_imgItem_img">
                        <img src="../../assets/img/brand-img6.png" alt="" />
                    </div>
                    <div class="brand-wrap_imgItem_box">
                        <img src="../../assets/img/brand-icon5.png" alt="" />
                        <p class="u-m-t-20">严格检测</p>
                    </div>
                </div>
                <div class="brand-wrap_imgItem">
                    <div class="brand-wrap_imgItem_box">
                        <p class="u-m-b-20">反复测试</p>
                        <img src="../../assets/img/brand-icon5.png" alt="" />
                    </div>
                    <div class="brand-wrap_imgItem_img">
                        <img src="../../assets/img/brand-img7.png" alt="" />
                    </div>
                </div>
                <div class="brand-wrap_imgItem">
                    <div class="brand-wrap_imgItem_img">
                        <img src="../../assets/img/brand-img8.png" alt="" />
                    </div>
                    <div class="brand-wrap_imgItem_box">
                        <img src="../../assets/img/brand-icon5.png" alt="" />
                        <p class="u-m-t-20">舒适版型</p>
                    </div>
                </div>
            </div>
            <div class="brand-wrap_imgBox">
                <div class="brand-wrap_imgBox_item">
                    <img src="../../assets/img/brand-img9.png" alt="" />
                </div>
                <div class="brand-wrap_imgBox_item">
                    <img src="../../assets/img/brand-img10.png" alt="" />
                </div>
            </div> -->
        </div>

        <!-- <div class="brand-wrap_box2">
            <div class="brand-wrap_list">
                <div class="brand-wrap_item brand-wrap_item_line">
                    <div class="brand-wrap_item_img">
                        <img src="../../assets/img/brand-icon2.png" alt="">
                    </div>
                    <h3>售前</h3>
                    <p>从方案设计、款式确认到样衣展示，全程与校方紧密配合，提供全面的数据采集技术支持，做好售前宣导</p>
                </div>
                <div class="brand-wrap_item brand-wrap_item_line">
                    <div class="brand-wrap_item_img">
                        <img src="../../assets/img/brand-icon3.png" alt="">
                    </div>
                    <h3>售中</h3>
                    <p>根据校服产品货物配发期的特殊性合理安排校服配发系统根据学校需要定期提供调换货服务确保每位学生穿上合体、满意的校服</p>
                </div>
                <div class="brand-wrap_item">
                    <div class="brand-wrap_item_img">
                        <img src="../../assets/img/brand-icon4.png" alt="">
                    </div>
                    <h3>售后</h3>
                    <p>专属400售后电话服务，专属售后人员全程跟进。未经穿着、在不影响二次销售的情况下提供退换货服务，免除校方及家长后顾之忧</p>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {};
</script>
<style lang="scss">
.brand-wrap {
    width: 100%;
    min-width: $width;
    .m-brand-font1 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 32px;
        color: #222222;
        text-align: center;
    }
    .m-brand-font2 {
        font-size: 15px;
        color: #222;
        font-weight: 800;
        line-height: 32px;
        text-align: center;
    }
    .brand-wrap_bg {
        // height: 600px;
        // background: url(../../assets/img/brand-bg1.png) no-repeat;
        // background-position: center;
        // background-size: 1920px 600px;
         width: 100%;
        // height: 600px;
        // background: url(../../assets/img/introduce-bg.png) no-repeat;
        // background-position: center;
        // background-size: 1920px 600px;
        img{
            width: 100%;
            height: auto;
            display: block;
        }
    }
    .brand-wrap_box1 {
        .brand-wrap_title {
            display: flex;
            justify-content: center;
            align-content: center;
            padding-top: 100px;
            span {
                font-size: 36px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 46px;
                color: #0073DF;
                margin-right: 14px;
            }
        }
        .brand-wrap_list {
            display: flex;
            justify-content: space-between;
            width: $width;
            margin: 0 auto;
            padding-top: 100px;
            .brand-wrap_item {
                width: 380px;
                .brand-wrap_item_img {
                    width: 380px;
                    height: 420px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .brand-wrap_item_title {
                    display: flex;
                    align-items: center;
                    padding-top: 30px;
                    span {
                        font-size: 24px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 32px;
                        color: #0073DF;
                        padding-right: 15px;
                    }
                    img {
                        width: 36px;
                        height: 24px;
                    }
                }
                p {
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 25px;
                    color: #222222;
                    padding-top: 16px;
                }
            }
        }
        .brand-wrap_bg2 {
            width: 100%;
            height: 90px;
            background: url(../../assets/img/brand-bg2.png) no-repeat;
            background-position: center;
            background-size: 1920px 90px;
            margin-top: 100px;
        }
        .brand-wrap_imgList {
            display: flex;
            width: 100%;
            justify-content: center;
            padding: 100px 0;
            .brand-wrap_imgItem {
                width: 240px;
                .brand-wrap_imgItem_img {
                    width: 100%;
                    height: 503px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .brand-wrap_imgItem_box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 150px;
                    p {
                        font-size: 24px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 32px;
                        color: #666666;
                    }
                }
            }
        }
        .brand-wrap_imgBox {
            display: flex;
            width: 100%;
            .brand-wrap_imgBox_item {
                display: flex;
                flex: 1;
                img {
                    width: 100%;
                    height: auto;
                }
            }
        }
    }
    .brand-wrap_box2{
        width: 100%;
        padding: 100px 0;
        .brand-wrap_list{
          display: flex;
          justify-content: space-between;
          width: $width;
          margin: 0 auto;
          .brand-wrap_item{
              position: relative;
              width: 370px;
              .brand-wrap_item_img{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100px;
                height: 100px;
                background: url(../../assets/img/brand-icon1.png) no-repeat;
                background-size: 100% 100%;
              }
              h3{
                  font-size: 20px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  line-height: 26px;
                  color: #666666;
                  margin-top: 30px;
              }
              p{
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  line-height: 20px;
                  color: #666666;
                  width: 281px;
                  margin-top: 30px;
              }
          }
          .brand-wrap_item_line{
              &::after{
                content: '';
                position: absolute;
                right: 0;
                bottom: 0;
                width: 1px;
                height: 135px;
                background: #DDDDDD;
              }
          }
        }
    }
}

.brand-list{
    width: 1400px;
    margin: 70px auto;
    .brand-item{
        width: 100%;
        display: flex;
        .brand-img{
            width: 50%;
            height: 350px;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }
        }
        .brand-title{
            width: 50%;
            height: 350px;
            background: #f8f8f8;
            padding: 0 110px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .brand-text{
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #0073DF;
            }
            .brand-p{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 29px;
                margin-top:10px;
            }
        }
    }
}
.brand-icon-box{
    width: 1060px;
    margin: 80px auto;
    display: flex;
    justify-content: space-between;
    .brand-icon{
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
            width: 100px;
            height: 100px;
        }
        p{
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            margin-top: 40px;
        }
    }
}
</style>
